import { call, put, takeLatest } from 'redux-saga/effects';
import type { Profile, ProfileComponent } from '@nx/domain';
import { recordProfileView } from '../../services/profileCallables';
import { profileRepository } from '../../services/profileRepositories';
import {
  publicProfileFailed,
  publicProfileLoadRequested,
  publicProfileLoaded,
} from '../slices/publicProfileSlice';

function shouldRecordView(profileId: string): boolean {
  if (typeof sessionStorage === 'undefined') return true;
  const key = `profile-view-${profileId}`;
  if (sessionStorage.getItem(key)) return false;
  sessionStorage.setItem(key, '1');
  return true;
}

export function* handlePublicProfileLoad(
  action: ReturnType<typeof publicProfileLoadRequested>,
): Generator<unknown, void, unknown> {
  try {
    const slug = action.payload;
    const profile = (yield call(
      [profileRepository, profileRepository.getBySlugPublished],
      slug,
    )) as Profile | null;
    if (!profile) {
      yield put(publicProfileLoaded(null));
      return;
    }
    const components = (yield call(
      [profileRepository, profileRepository.listComponents],
      profile.id,
    )) as ProfileComponent[];
    yield put(publicProfileLoaded({ profile, components }));
    if (shouldRecordView(profile.id)) {
      try {
        yield call(recordProfileView, { profileId: profile.id });
      } catch {
        // non-blocking analytics
      }
    }
  } catch (e) {
    yield put(publicProfileFailed(e instanceof Error ? e.message : 'Failed to load profile'));
  }
}

export function* publicProfileSaga() {
  yield takeLatest(publicProfileLoadRequested.type, handlePublicProfileLoad);
}
